import axios from 'axios';

const csrfToken = document.head.querySelector('meta[name=csrf-token]').getAttribute('content');

export default axios.create({
    baseURL: process.env.CHATBOT_DOMAIN,
    headers: {
        'X-CSRF-TOKEN': csrfToken
    }
});
